import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';
import UnitOfferForm from '../unitOffer/UnitOfferForm';
import { updateUnitOffer } from '../../services/unitOfferService';

function UnitOfferEdit(props) {
  const { unitOffer } = props;

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'Idle mode.'
  });

  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

  const initialValues = {
    courseOfferId: unitOffer.courseOfferId,
    unitCode: unitOffer.unitCode,
    unitDescription: unitOffer.unitDescription,
    startDate: moment(unitOffer.startDateFormatted, dateFormat),
    endDate: moment(unitOffer.endDateFormatted, dateFormat),
    maxRegistrations: !!unitOffer.maxRegistrations
      ? unitOffer.maxRegistrations
      : 0,
    minRegistrations: !!unitOffer.minRegistrations
      ? unitOffer.minRegistrations
      : 0
  };

  async function onSubmit(values) {
    let payload = {
      ...values,
      startDate: values.startDate.utc().format(),
      endDate: values.endDate.utc().format()
    };

    if (validateDate(payload.startDate, payload.endDate)) {
      setStatus({ type: 'LOADING', message: 'Is waiting for response' });
      await updateUnitOffer(unitOffer.unitOfferId, payload)
        .then((res) => {
          setStatus({ type: 'SUCCESS', message: 'Succesful response' });
          props.updateUnitOffer(payload);
        })
        .catch((err) => {
          alert(err);
          setStatus({
            type: 'ERROR',
            message: 'Error/Fields should not be empty!'
          });
        });
    } else
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!'
      });
  }

  function validateDate(startDate, endDate) {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  }

  return (
    <Modal
      title={`Edit Unit Offer ${unitOffer.unitOfferId}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <UnitOfferForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          courses={props.courses}
        />
      )}
    </Modal>
  );
}

export default UnitOfferEdit;
